<script>
import { isPc } from './utils'
export default {
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    date: {
      type: Date
    },
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      hover: false
    }
  },
  computed: {
    isNow () {
      const now = new Date()
      return this.date && this.date.getYear() === now.getYear() && this.date.getMonth() === now.getMonth() && this.date.getDate() === now.getDate()
    },
    dayButtonClass () {
      return {
        selected: false,
        hover: this.hover,
        'mu-day-button': true,
        disabled: this.disabled,
        now: this.isNow,
        'mu-day-multiple-button': true,
        'mu-day-selected-button': this.text
      }
    }
  },
  methods: {
    handleHover () {
      if (isPc() && !this.disabled) this.hover = true
    },
    handleHoverExit () {
      this.hover = false
    },
    handleClick (event) {
      this.$emit('click', event)
    }
  },
  render (h) {
    let array = []
    if (this.text) {
      array = this.text.split('/').map(item => {
        return h('span', {
          class: 'mu-day-button-multiple-text',
          domProps: {
            innerHTML: item
          }
        })
      })
    }
    return this.date ? h('button', {
      class: this.dayButtonClass,
      on: {
        mouseenter: this.handleHover,
        mouseleave: this.handleHoverExit,
        click: this.handleClick
      },
      domProps: {
        disabled: this.disabled
      }
    }, [
      h('div', {class: 'mu-day-button-bg'}),
      h('span', {
        class: 'mu-day-button-text',
        domProps: {
          innerHTML: this.date.getDate()
        }
      }),
      h('span', {
        class: 'mu-day-button-multiple'
      }, array)
    ]) : h('span', {class: 'mu-day-empty'})
  }
}
</script>
<style>
  .mu-day-multiple-button {
  }
  .mu-day-selected-button {
    background: orange;
  }
  .mu-day-selected-button .mu-day-button-text {
    color: #ffffff;
  }
  /* .mu-day-button.now .mu-day-button-text {
    color: #2196f3!important;
  } */
  .mu-day-button-multiple {
    display: inline-block;
    position: absolute;
    top: 25px;
    left: 0;
    right: 0;
    background: orange;

  }
  .mu-day-button-multiple-text {
    display: block;
    line-height: 16px;
    color: #ffffff;
    padding-bottom: 3px;
  }
</style>


// WEBPACK FOOTER //
// src/components/NewDatePicker/dayButton.vue